const defaultWidth = 16;
const defaultHeight = 16;

export const EyePreviewIcon = ({
  width = defaultWidth,
  height = defaultHeight,
  color = "#24292E",
}: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.00033 4.66634C10.527 4.66634 12.7803 6.08634 13.8803 8.33301C12.7803 10.5797 10.5337 11.9997 8.00033 11.9997C5.46699 11.9997 3.22033 10.5797 2.12033 8.33301C3.22033 6.08634 5.47366 4.66634 8.00033 4.66634ZM8.00033 3.33301C4.66699 3.33301 1.82033 5.40634 0.666992 8.33301C1.82033 11.2597 4.66699 13.333 8.00033 13.333C11.3337 13.333 14.1803 11.2597 15.3337 8.33301C14.1803 5.40634 11.3337 3.33301 8.00033 3.33301ZM8.00033 6.66634C8.92033 6.66634 9.66699 7.41301 9.66699 8.33301C9.66699 9.25301 8.92033 9.99967 8.00033 9.99967C7.08033 9.99967 6.33366 9.25301 6.33366 8.33301C6.33366 7.41301 7.08033 6.66634 8.00033 6.66634ZM8.00033 5.33301C6.34699 5.33301 5.00033 6.67967 5.00033 8.33301C5.00033 9.98634 6.34699 11.333 8.00033 11.333C9.65366 11.333 11.0003 9.98634 11.0003 8.33301C11.0003 6.67967 9.65366 5.33301 8.00033 5.33301Z"
        fill={color}
      />
    </svg>
  );
};

EyePreviewIcon.displayName = "EyePreviewIcon";
